import CronOldList from './cron-old.list';
import CronOldShow from './cron-old.show';

export default {
  list: CronOldList,
  show: CronOldShow,
};
